/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetLowerthirdByDateQueryResponse, PntSegmentsControllerGetLowerthirdByDatePathParams, PntSegmentsControllerGetLowerthirdByDateQueryParams } from "../models/PntSegmentsControllerGetLowerthirdByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntSegmentsControllerGetLowerthirdByDate } from "../axios/pntSegmentsControllerGetLowerthirdByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntSegmentsControllerGetLowerthirdByDateQueryKey = (slug: PntSegmentsControllerGetLowerthirdByDatePathParams["slug"], params: PntSegmentsControllerGetLowerthirdByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/lowerthird', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntSegmentsControllerGetLowerthirdByDateQueryKey = ReturnType<typeof pntSegmentsControllerGetLowerthirdByDateQueryKey>

export function pntSegmentsControllerGetLowerthirdByDateQueryOptions(slug: PntSegmentsControllerGetLowerthirdByDatePathParams["slug"], params: PntSegmentsControllerGetLowerthirdByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntSegmentsControllerGetLowerthirdByDateQueryKey(slug, params)
        return queryOptions<PntSegmentsControllerGetLowerthirdByDateQueryResponse, ResponseErrorConfig<Error>, PntSegmentsControllerGetLowerthirdByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntSegmentsControllerGetLowerthirdByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the lowerthirds for a given time range
 * {@link /pnt/v2/segments/:slug/lowerthird}
 */
export function usePntSegmentsControllerGetLowerthirdByDate<TData = PntSegmentsControllerGetLowerthirdByDateQueryResponse, TQueryData = PntSegmentsControllerGetLowerthirdByDateQueryResponse, TQueryKey extends QueryKey = PntSegmentsControllerGetLowerthirdByDateQueryKey>(slug: PntSegmentsControllerGetLowerthirdByDatePathParams["slug"], params: PntSegmentsControllerGetLowerthirdByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntSegmentsControllerGetLowerthirdByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntSegmentsControllerGetLowerthirdByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntSegmentsControllerGetLowerthirdByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}